import { ROUTES_META, type RouteMeta } from '@core/routes';

/** Home shows this many; AppLayout stores a deeper history. */
export const LAST_OPENED_DISPLAY = 3;
export const LAST_OPENED_STORED = 20;

type NavMount = {
  path: string;
  label: string;
};

const trackedNav: NavMount[] = Object.values(ROUTES_META)
  .filter((r) => r.trackRecent)
  .map((r) => ({ path: r.path, label: r.label }));

function matchesMount(pathname: string, mount: string): boolean {
  if (mount === '/') return pathname === '/';
  return pathname === mount || pathname.startsWith(`${mount}/`);
}

/** Longest matching mount wins (e.g. `/admin` over a hypothetical `/`). */
function matchNavMount(pathname: string, nav: readonly NavMount[]): NavMount | undefined {
  let best: NavMount | undefined;
  for (const item of nav) {
    if (!matchesMount(pathname, item.path)) continue;
    if (!best || item.path.length > best.path.length) best = item;
  }
  return best;
}

export function labelForPath(pathname: string): string | undefined {
  return matchNavMount(pathname, trackedNav)?.label;
}

/** Canonical SPA root for a path (`/tearsheets/42` → `/tearsheets`); undefined when untracked. */
export function canonicalSpaPath(pathname: string): string | undefined {
  return matchNavMount(pathname, trackedNav)?.path;
}

/** Longest matching route meta for any mount (tracked or not). */
export function metaForPath(pathname: string): RouteMeta | undefined {
  let best: RouteMeta | undefined;
  for (const route of Object.values(ROUTES_META)) {
    if (!matchesMount(pathname, route.path)) continue;
    if (!best || route.path.length > best.path.length) best = route;
  }
  return best;
}
